<template>
  <Variety />
</template>

<script>
import Variety from '@/components/variety/varieties.vue'
export default {
  components: {
    Variety,
  },
}
</script>
